import { NumberInput, Switch } from '@mantine/core';
import AgentCatalogFields from '../AgentCatalogFields';
import HelpPopover from '../../HelpPopover/HelpPopover';
import SettingRow from '../../SettingRow/SettingRow';
import { HELP, applyExample } from './superAdminHelp';

const CatalogSearchSection = ({ chatBot, handleChange, accountId, domainId, domain }) => (
  <>
    <AgentCatalogFields
      chatBot={chatBot}
      handleChange={handleChange}
      accountId={accountId}
      domainId={domainId}
      domain={domain}
    />

    <SettingRow
      label="Products per search"
      htmlFor="productsNumber"
      help={
        <HelpPopover
          {...HELP.productsNumber}
          onUse={applyExample(handleChange, 'productsNumber', chatBot.productsNumber)}
        />
      }
    >
      <NumberInput
        id="productsNumber"
        name="productsNumber"
        size="xs"
        w={120}
        value={chatBot.productsNumber || ''}
        min={0}
        max={50}
        placeholder="5"
        onChange={(value) => handleChange({ target: { name: 'productsNumber', value: value === '' ? 5 : value } })}
      />
    </SettingRow>

    <SettingRow
      label="Multi-locale products"
      htmlFor="multiLocaleProducts"
      help={<HelpPopover {...HELP.multiLocaleProducts} />}
    >
      <Switch
        id="multiLocaleProducts"
        size="xs"
        checked={chatBot.multiLocaleProducts === true}
        onChange={(e) => handleChange({ target: { name: 'multiLocaleProducts', value: e.currentTarget.checked } })}
      />
    </SettingRow>
  </>
);

export default CatalogSearchSection;
